import { z } from 'zod';

export const CountryISO3CodeSchema = z.string().length(3);
export type CountryISO3Code = z.infer<typeof CountryISO3CodeSchema>;

export const CountryISO2CodeSchema = z.string().length(2);
export type CountryISO2Code = z.infer<typeof CountryISO2CodeSchema>;

export const CountryNameSchema = z.string();
export type CountryName = z.infer<typeof CountryNameSchema>;
